import { CountUp } from "./CountUp";
import { PAIN_HERO, PAIN_STATS, SOURCES_NOTE } from "@/data/content";

export const PROBLEM_HEADING = "Hand-built submittals take weeks, and still fail reviews.";

export const PainStats = () => (
  <section id="problem" className="cd-section border-t border-[#bdbdb4]" data-testid="pain-stats-section">
    <div className="mx-auto max-w-[1360px] px-5 sm:px-8">
      <div className="cd-reveal max-w-4xl">
        <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#ff6600]" data-testid="problem-eyebrow">The problem</p>
        <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.1] tracking-[-0.025em] text-[#292929] sm:text-4xl lg:text-[44px]" data-testid="problem-title">
          {PROBLEM_HEADING}
        </h2>
      </div>
      <div className="cd-reveal mt-12">
        <div className="border border-[#bdbdb4] px-6 py-14 text-center sm:py-20" data-testid="pain-hero">
          <p className="font-display text-[44px] font-semibold leading-[1.1] tracking-[-0.045em] text-[#ff6600] tabular-nums sm:text-7xl lg:text-8xl">
            <CountUp value={PAIN_HERO.value} duration={1600} testId="pain-hero-value" />
          </p>
          <p className="mt-5 text-base text-[#55554f] sm:text-lg" data-testid="pain-hero-caption">{PAIN_HERO.caption}</p>
        </div>
      </div>
      <div className="grid grid-cols-1 border-l border-[#bdbdb4] sm:grid-cols-3">
        {PAIN_STATS.map((s, i) => (
          <article key={s.value} className="cd-stat cd-reveal group border-b border-r border-[#bdbdb4] p-5 sm:p-8" style={{ transitionDelay: `${i * 120}ms` }} data-testid={`pain-stat-${i + 1}`}>
            <p className="whitespace-nowrap font-display text-[28px] font-semibold tabular-nums tracking-[-0.04em] text-[#292929] sm:text-5xl lg:text-[44px] xl:text-5xl">
              {s.prefix && <span className="text-[#94948a]">{s.prefix}</span>}
              <CountUp value={s.value} delay={i * 120} testId={`pain-stat-value-${i + 1}`} />
            </p>
            <p className="mt-3 text-sm leading-relaxed text-[#55554f] sm:text-[15px]" data-testid={`pain-stat-caption-${i + 1}`}>{s.caption}</p>
          </article>
        ))}
      </div>
      <p className="mt-6 font-mono text-[11px] leading-relaxed text-[#77776f]" data-testid="pain-stats-footnote">{SOURCES_NOTE}</p>
    </div>
  </section>
);
